import React, {useState} from 'react';
import round from 'lodash/round';
import moment from 'moment';
import {useNavigate} from 'react-router-dom';

import useUser from '../../hooks/useUser';
import AppDashboard from '../AppDashboard';
import CalendarScreen from '../../components/calendar/CalendarScreen';
import { useGetSessionsQuery } from '../../redux/services/sessionApi';
import { useGetEventsQuery } from '../../redux/services/eventApi';
import { useGetProviderAvailabilitiesQuery } from '../../redux/services/providerAvailabilityApi';
import useIsMobile from '../../hooks/useIsMobile';
import { getStartAndEndDate } from '../../components/calendar/calendarUtils';

const ProviderCalendarPage = () => {
  const isMobile = useIsMobile();
  const [date, setDate] = useState(new Date());
  const [calendarView, setCalendarView] = useState(isMobile ? 'day' : 'week');
  const user = useUser();
  const providerId = user?.provider?.id;
  const {startDate, endDate} = getStartAndEndDate({date, calendarView});
  const query = {
    provider_id: providerId,
    start_time: startDate, 
    end_time: endDate,
    limit: 100,
  };
  const sessionQuery = useGetSessionsQuery(query, {skip: !providerId});
  const sessions = sessionQuery?.data?.data || [];
  const eventsQuery = useGetEventsQuery({
    provider_id: providerId,
    start_time: startDate, 
    end_time: endDate,
  }, {skip: !providerId});
  const events = eventsQuery?.data?.data || eventsQuery?.data || [];
  const availabilityQuery = useGetProviderAvailabilitiesQuery(
    {provider_id: providerId},
    {skip: !providerId}
  );
  const availabilities = availabilityQuery?.data?.data || [];
  const metrics = !sessions || !sessions.length ? [] : [
    {
      label: 'Total Sessions', 
      value: sessions.length
    },
    {
      label: 'Total Care Hours', 
      value: round(sessions.reduce((acc, s) => acc + s.duration, 0) / 60, 1),
    },
  ];
  const childProps = {
    calendarView,
    date,
    sessions,
    events,
    availabilities,
    metrics,
    loading: !user || sessionQuery?.isLoading,
    useSummaries: true,
    onDateChange: (e, dt) => setDate(dt),
    onCalendarViewChange: (e, v) => setCalendarView(v),
    error: sessionQuery?.isError ? sessionQuery.error : null,
  };
  return (
    <AppDashboard
      title='Provider Calendar'
      loading={childProps.loading} 
      error={childProps.error} 
    >
      <CalendarScreen {...childProps} />
    </AppDashboard>
  );
};

export default ProviderCalendarPage;